import * as Yup from 'yup';

export const yupBaseString = (label?: string) => {
  const validation = Yup
    .string()
    .max(255, `${label || 'This field'} cannot exceed 255 characters`)
    .trim()
    .transform(value => value.replace(/\n/g, ' '));

  return label ? validation.label(label) : validation;
};

export const yupBaseEmail = (label?: string) =>
  yupBaseString(label).matches(
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    'Please enter a valid email',
  );
